import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiService } from '@app/core/http/api.service';

import { Observable ,  of } from 'rxjs';
import { flatMap, catchError } from 'rxjs/operators';

@Injectable()
export class ImageService extends ApiService {

    private options = {
        headers: this.defaultHeaders,
        observe: 'body' as 'body',
    };

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public get(userId?: string): Observable<string> {

        const options = {
            ...this.options,
            responseType: 'blob' as 'json',
        };

        let url = '';
        if (userId) { url = `https://graph.microsoft.com/beta/users/${userId}/photos/48x48/$value`; }
        else { url = `https://graph.microsoft.com/beta/me/photos/48x48/$value`; }

        return this.httpClient.get<Blob>(url, options).pipe(
            flatMap(monblob => this.convertBlobToBase64(monblob)),
            catchError(_ => of('../../assets/images/no-user-photo.jpg')),
        );
    }

    private convertBlobToBase64(blob: Blob): Observable<string> {
        return Observable.create(obs => {
            if (!(blob instanceof Blob)) {
              obs.error(new Error('`blob` must be an instance of File or Blob.'));
              return;
            }

            const reader = new FileReader();

            reader.onerror = err => obs.error(err);
            reader.onabort = err => obs.error(err);
            reader.onload = () => obs.next(reader.result);
            reader.onloadend = () => obs.complete();

            return reader.readAsDataURL(blob);
        });
    }
}
